import React, { useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import ItemService from "../../../services/supplier_appCommonService"; 

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PdfViewerUpload2 = ({
  onOcrExtract,
  onSuccessUpload,
  getUploadedFiles,
  value,
  name,
  id,
  attachmentUrl,
}) => {
  const [pdfFile, setPdfFile] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(false);

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file?.type === "application/pdf") {
      setPdfFile(URL.createObjectURL(file));
      setSelectedFiles([file]);
    } else {
      alert("Please upload a valid PDF file");
    }
  };

  const handleRemove = () => {
    URL.revokeObjectURL(pdfFile);
    setPdfFile(null);
    setSelectedFiles(null);
  };

  const uploadFiles = async () => {
    if (!selectedFiles) return;
    setUploadStatus(true);
    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append("files", file));
      if (value) formData.append("attachmentId", value);

      await ItemService.uploadFiles(formData).then((item) => {
        item.fieldName = name;
        item.fieldId = id;
        if (typeof onSuccessUpload === "function") onSuccessUpload(item);
        if (typeof getUploadedFiles === "function") getUploadedFiles(item?.attachmentId);
      });
    } catch (err) {
      console.error("Upload failed:", err);
    } finally {
      setUploadStatus(false);
    }
  };

  return (
    <div style={{ padding: "10px" }}>
      <h4>Upload PDF</h4>

      {/* File input */}
      {!pdfFile && (
        <input type="file" accept="application/pdf" onChange={handleFileUpload} />
      )}

      {/* New file picked — show upload/remove buttons */}
      {pdfFile && (
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <button onClick={handleRemove}
            style={{ background: "red", color: "white", padding: "6px 10px", border: "none", cursor: "pointer" }}>
            Remove PDF
          </button>
          <button onClick={uploadFiles} disabled={uploadStatus}
            style={{ background: uploadStatus ? "#999" : "#0d6efd", color: "white", padding: "6px 14px", border: "none", cursor: uploadStatus ? "not-allowed" : "pointer" }}>
            {uploadStatus
              ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Uploading...</>
              : <><i className="bi bi-cloud-upload me-2" />Upload PDF</>}
          </button>
        </div>
      )}

      {/* ✅ Newly picked file — use react-pdf-viewer (blob URL, no CORS) */}
      {pdfFile && (
        <Worker workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}>
          <div style={{ height: "750px" }}>
            <Viewer fileUrl={pdfFile} plugins={[defaultLayoutPluginInstance]} />
          </div>
        </Worker>
      )}

      {/* ✅ Existing S3 file — use iframe (bypasses CORS completely) */}
      {!pdfFile && attachmentUrl && (
        <iframe
          src={attachmentUrl}
          title="Invoice PDF"
          style={{ width: "100%", height: "750px", border: "none" }}
        />
      )}
    </div>
  );
};

export default PdfViewerUpload2;